import styled from 'styled-components';

export const NotFoundContainer = styled.div`
  padding: 16px;
  width: 100dvw;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

export const NotFoundContent = styled.div`
  width: 100%;
  max-width: 400px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background-color: #f9faf9;
  border-radius: 8px;
  text-align: center;
`;

export const NotFoundIcon = styled.div`
  font-size: 72px;
  color: #5f522d;
  margin-bottom: 8px;
`;

export const NotFoundTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

export const NotFoundButton = styled.div`
  width: 100%;
  max-width: 200px;
  margin-top: 16px;
`;
